export default __webpack_public_path__ + "static/media/head03_en_pc.23ee2525.png";